import { ArrowForwardIos } from "@mui/icons-material";
import {
  Box,
  Button,
  Card,
  CardContent,
  Checkbox,
  Dialog,
  DialogContent,
  Divider,
  FormControl,
  IconButton,
  InputLabel,
  ListItemText,
  MenuItem,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { useFormik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { ButtonGroup } from "react-bootstrap";
import { useAppDispatch } from "../../../Redux/hooks";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { UrlConstant } from "../../../commom/UrlConstant";
import Axios from "../../../config/axios";
import { logout } from "../../../Redux/authSlice";
import Successpopup from "../SharedComponent/Successpopup";
import {
  hasBrowserPushApis,
  isWebPushEnabled,
  registerDevice,
  requestPermissionFromUserAction,
  unlinkDevice,
} from "../../../services/pushNotifications";

interface FormValues {
  input_1: string;
  input_2: string;
  input_3: string;
  input_4: string;
  input_5: string;
  input_6: string;
  input_7: string;
  input_8: string;
}

const initialValues: FormValues = {
  input_1: "",
  input_2: "",
  input_3: "",
  input_4: "",
  input_5: "",
  input_6: "",
  input_7: "",
  input_8: "",
};

function Setting() {
  const [percentage, setpercentage] = useState("10");
  const [changepin, setchangepin] = useState(false);
  const [input, setInput] = useState("");
  const [deleteaccount, setdeleteaccount] = useState(false);
  const [selectedDays, setSelectedDays] = useState<string[]>([]);
  const [pushNotificationEnabled, setPushNotificationEnabled] = useState(false);
  const [biometricEnabled, setBiometricEnabled] = useState(false);
  const [profileAccessEnabled, setProfileAccessEnabled] = useState(false);
  const inputRefs = useRef<(HTMLInputElement | null)[]>([]);
  const [isLogin, setIsLogin] = useState<boolean>(false);
  const [showPin] = useState<boolean>(false);
  const [showPopup, setShowPopup] = useState(false); // State for controlling popup visibility
  const [msg, setmsg] = useState(''); // State for controlling popup visibility
  const [Success, setSuccess] = useState(false); // State for controlling popup visibility
  const [heading, setheading] = useState(''); // State for controlling popup visibility



  const days = [
    { value: 0, label: "Monday" },
    { value: 1, label: "Tuesday" },
    { value: 2, label: "Wednesday" },
    { value: 3, label: "Thursday" },
    { value: 4, label: "Friday" },
  ];
  const dispatch = useAppDispatch();
  const navigation = useNavigate();
  useEffect(() => {
    const fetchUserSettings = async () => {
      try {
        const response = await Axios.get(UrlConstant.Settings.usersettings);
        if (response.data.result) {
          const {
            profileMatchPercentage,
            frequency,
            isPushNotification,
            biometricLoginEnabled,
            canViewProfile
          } = response.data.data;

          setpercentage(profileMatchPercentage.toString());
          const selectedDayLabels = frequency
            .map(
              (day: number) => days.find((d) => d.value === day)?.label || ""
            )
            .filter(Boolean);
          setSelectedDays(selectedDayLabels);
          setPushNotificationEnabled(isPushNotification || false);
          setBiometricEnabled(biometricLoginEnabled || false);
          setProfileAccessEnabled(canViewProfile || false)
        }
      } catch (error) {
        console.error("Error fetching user settings:", error);
      }
    };

    fetchUserSettings();
  }, []);

  const handleApiUpdate = async (updatedSettings: any) => {
    try {
      const response = await Axios.post(
        UrlConstant.Settings.setUserSetting,
        updatedSettings
      );
      if (response.data.result) {
        console.log("Settings updated successfully:", response.data);
      } else {
        console.error("Failed to update settings:", response.data.msg);
      }
    } catch (error) {
      console.error("Error updating settings:", error);
    }
  };

  const handlePercentageChange = (event: SelectChangeEvent<string>) => {
    const newPercentage = event.target.value;
    setpercentage(newPercentage);

    // Call API
    handleApiUpdate({
      frequency: selectedDays.map(
        (day) => days.find((d) => d.label === day)?.value || 0
      ),
      isPushNotification: pushNotificationEnabled,
      profileMatchPercentage: newPercentage,
    });
  };

  const handleDaysChange = (event: SelectChangeEvent<string[]>) => {
    const value = event.target.value;
    const newDays = typeof value === "string" ? value.split(",") : value;
    setSelectedDays(newDays);

    // Call API
    handleApiUpdate({
      frequency: newDays.map(
        (day) => days.find((d) => d.label === day)?.value || 0
      ),
      isPushNotification: pushNotificationEnabled,
      profileMatchPercentage: percentage,
    });
  };
  const handlePushNotificationChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const isEnabled = event.target.checked;
    setPushNotificationEnabled(isEnabled);

    // Start the browser permission prompt synchronously inside the click
    // gesture (required by Safari); it is awaited after the existing API call.
    const webPermissionPromise =
      isEnabled && isWebPushEnabled() && hasBrowserPushApis()
        ? requestPermissionFromUserAction()
        : null;

    try {
      const response = await Axios.post(UrlConstant.Settings.setUserSetting, {
        frequency: selectedDays.map(
          (day) => days.find((d) => d.label === day)?.value || 0
        ),
        isPushNotification: isEnabled,
        profileMatchPercentage: percentage,
      });

      if (response.data.result) {
        console.log("Push notification setting updated successfully.");
      } else {
        console.error(
          "Failed to update push notification setting:",
          response.data.msg
        );
      }
    } catch (error) {
      console.error("Error updating push notification setting:", error);
    }

    // Web push device handling (additive, best-effort, feature flagged).
    if (isWebPushEnabled() && hasBrowserPushApis()) {
      if (isEnabled) {
        const permission = await webPermissionPromise;
        if (permission === "granted") await registerDevice();
      } else {
        await unlinkDevice();
      }
    }
  };

  const handleBiometricChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const isEnabled = event.target.checked;
    setBiometricEnabled(isEnabled);

    try {
      const response = await Axios.post(UrlConstant.Settings.setUserSetting, {
        frequency: selectedDays.map(
          (day) => days.find((d) => d.label === day)?.value || 0
        ),
        isPushNotification: pushNotificationEnabled,
        profileMatchPercentage: percentage,
        biometricLoginEnabled: isEnabled,
      });

      if (response.data.result) {
        console.log("Biometric setting updated successfully.");
      } else {
        console.error("Failed to update biometric setting:", response.data.msg);
      }
    } catch (error) {
      console.error("Error updating biometric setting:", error);
    }
  };

  const handleProfileAccessChange = async (
    event: React.ChangeEvent<HTMLInputElement>
) => {
    const isEnabled = event.target.checked;
    setProfileAccessEnabled(isEnabled);

    try {
        const response = await Axios.post(UrlConstant.Settings.setUserSetting, {
            frequency: selectedDays.map(
                (day) => days.find((d) => d.label === day)?.value || 0
            ),
            isPushNotification: pushNotificationEnabled,
            profileMatchPercentage: percentage,
            biometricLoginEnabled: biometricEnabled,
            canViewProfile: isEnabled,
        });

        if (response.data.result) {
            console.log("Profile access setting updated successfully.");
        } else {
            console.error("Failed to update profile access setting:", response.data.msg);
        }
    } catch (error) {
        console.error("Error updating profile access setting:", error);
    }
};
  const handleDeleteAccount = async () => {
    if (input !== "Delete") {
      // Show SweetAlert when the input does not match "Delete"
      Swal.fire({
        icon: 'warning',
        title: 'Confirmation Required',
        text: 'Please type "Delete" to confirm.',
      });
      return;
    }

    try {
      const response = await Axios.get(UrlConstant.Settings.deleteAccount);

      if (response.data.status) {
        // Swal.fire({
        //   icon: 'success',
        //   title: 'Success',
        //   text: 'Account deleted successfully.',
        // })
        setheading('Success')
        setShowPopup(true)
        setSuccess(true)
        setmsg('Account deleted successfully.')
        // .then(() => {
        setdeleteaccount(false);
        dispatch(logout());
        // });
      } else {
        // Swal.fire({
        //   icon: 'error',
        //   title: 'Failed',
        //   text: 'Failed to delete the account. Please try again later.',
        // });
        setheading('Failed')
        setShowPopup(true)
        setmsg('Failed to delete the account. Please try again later.')
        //   .then(() => {

      }
    } catch (error) {
      // Swal.fire({
      //   icon: 'error',
      //   title: 'Error',
      //   text: 'Error occurred while deleting the account.',
      // });
      setShowPopup(true)
      setheading('Error')
      setmsg('Error occurred while deleting the account.')
    }
  };
  const handleaccount = () => {
    setdeleteaccount(!deleteaccount);
  };
  const handlepin = () => {
    setchangepin(!changepin);
  };
  const onSubmit = (values: FormValues) => {
    console.log("VAL : ", values);
    const creatpin =
      values.input_1 + values.input_2 + values.input_3 + values.input_4;
    const confirmpin =
      values.input_5 + values.input_6 + values.input_7 + values.input_8;

    console.log("PIN 1 : ", creatpin);
    console.log("PIN 2 : ", confirmpin);

    if (creatpin.length !== 4 && confirmpin.length !== 4) {
      // Swal.fire("Enter valid PIN");
      setShowPopup(true)
      setmsg('Enter valid PIN')

      return;
    }
    if (creatpin !== confirmpin) {
      // Swal.fire("PIN not matched");
      setShowPopup(true)
      setmsg('PIN not matched')
      return;
    }
    setPin(creatpin);
  };

  const handleKeyUp = (
    e: React.KeyboardEvent<HTMLInputElement>,
    index: number
  ) => {
    console.log(e.key);
    if (e.key === "Enter") {
      formik.handleSubmit();
    } else if (e.key === "Backspace") {
      inputRefs.current[index - 1]?.focus();
      formik.setFieldValue(`input_${index}`, "");
    } else if (inputRefs.current[index + 1]) {
      inputRefs.current[index + 1]?.focus();
    }
  };
  const formik = useFormik<FormValues>({
    initialValues,
    onSubmit,
  });

  const setPin = async (pin: any) => {
    const payLoad = {
      pin: pin,
    };
    try {
      const response = await Axios.post(UrlConstant.Auth.CreatePin, payLoad);

      const resData = response.data;
      if (resData.result === true) {
        if (resData.result === true) {
          // Swal.fire("PIN Changed Successfully");
          setheading('Success')
          setSuccess(true)
          setShowPopup(true)
          setmsg('PIN Chnaged Successfully')
          handlepin();
          formik.resetForm();
        }
      }
    } catch (error: any) {
      console.error("ERRR : ", error);
    }
  };
  const closePopup = () => {
    setShowPopup(false); // Function to close the popup
  };
  return (
    <>
      <Box
        sx={{ height: "fit-content", }}
        position="relative"
        className="bg-dak"
      >
        <Box sx={{ padding: "30px" }}>
          <Typography className="text-secondary" sx={{ marginBottom: "20px" }}>
            {" "}
            <span
              onClick={() => navigation(-1)}
              style={{ color: "#4A7AF2", cursor: "pointer" }}
            >
              More Options{" "}
            </span>{" "}
            / Settings
          </Typography>
          <Box width="100%">
            <Typography variant="h5" className="text-white" mb="20px">
              My Pick Settings
            </Typography>
            <Box
              display="flex"
              gap="20px"
              width="100%"
              alignItems="center"
              mb="20px"
            >
              <Card className="card" sx={{ width: "50%", height: "218px" }}>
                <CardContent sx={{ padding: "20px" }}>
                  <Typography
                    variant="h5"
                    fontWeight="bold"
                    className="text-white"
                  >
                    Percentage Profile Match
                  </Typography>
                  <Typography className="subtitle1 text-white" mb="20px">
                    Set the minimum percentage profile match value in order to
                    receive match value in order to receive my picks
                  </Typography>
                  <FormControl
                    fullWidth
                    className="text-secondary"
                    sx={{ mt: "20px" }}
                  >
                    <InputLabel
                      className="text-secondary"
                      sx={{ fontSize: "14px !important" }}
                      shrink={false}
                    >
                      <span>
                        Matching Percentage{" "}
                        <sup>
                          <i
                            className="fa-solid fa-star-of-life"
                            style={{ color: "#fa0000", fontSize: "0.5rem" }}
                          ></i>
                        </sup>
                      </span>
                    </InputLabel>
                    <Select
                      value={percentage}
                      onChange={handlePercentageChange}
                      variant="outlined"
                      sx={{
                        p: "13px",
                        mb: 0,
                        " .MuiFormControl-root": {
                          margin: "0px",
                          marginTop: "0px",
                        },
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: "#a3a3a3",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#f2674a",
                          },
                        },
                      }}
                    >
                      {Array.from({ length: 100 }, (_, i) => i + 1).map(
                        (value) => (
                          <MenuItem key={value} value={value.toString()}>
                            {value}%
                          </MenuItem>
                        )
                      )}
                    </Select>
                  </FormControl>
                </CardContent>
              </Card>
              <Card className="card" sx={{ width: "50%", height: "218px" }}>
                <CardContent sx={{ padding: "20px" }}>
                  <Typography
                    variant="h5"
                    fontWeight="bold"
                    className="text-white"
                  >
                    My Picks Frequency
                  </Typography>
                  <Typography className="subtitle1 text-white" mb="30px">
                    Select the days you would like to receive profile match my
                    picks
                  </Typography>
                  <FormControl
                    fullWidth
                    className="text-secondary"
                    sx={{ mt: "30px" }}
                  >
                    <InputLabel
                      className="text-secondary"
                      sx={{ fontSize: "14px !important" }}
                      shrink={false}
                    >
                      <span>
                        Select Frequency{" "}
                        <sup>
                          <i
                            className="fa-solid fa-star-of-life"
                            style={{ color: "#fa0000", fontSize: "0.5rem" }}
                          ></i>
                        </sup>
                      </span>
                    </InputLabel>
                    <Select
                      multiple
                      value={selectedDays}
                      onChange={handleDaysChange}
                      renderValue={() => `${selectedDays.length} Days`}
                      variant="outlined"
                      sx={{
                        p: "13px",
                        mb: 0,
                        " .MuiFormControl-root": {
                          margin: "0px",
                          marginTop: "0px",
                        },
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor:
                              selectedDays.length > 0
                                ? "#f2674a !important"
                                : "#a3a3a3 !important",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor:
                              selectedDays.length > 0
                                ? "#f2674a !important"
                                : "#f44336 !important",
                          },
                        },
                      }}
                    >
                      {days.map((day) => (
                        <MenuItem key={day.value} value={day.label}>
                          <Checkbox
                            checked={selectedDays.includes(day.label)}
                          />
                          <ListItemText primary={day.label} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </CardContent>
              </Card>
            </Box>
            <Box
              display="flex"
              gap="20px"
              width="100%"
              alignItems="center"
              mb="20px"
            >
              <Card
                sx={{ height: "100px", width: "50%", padding: "20px" }}
                className="card"
              >
                <CardContent
                  sx={{
                    padding: "0px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Box>
                    <Typography
                      variant="h5"
                      fontWeight="bold"
                      className="text-white"
                    >
                      Push Notification
                    </Typography>
                    <Typography variant="subtitle1" className="text-white">
                      Turn on to receive the Push Notifications
                    </Typography>
                  </Box>
                  <Switch
                    checked={pushNotificationEnabled}
                    onChange={handlePushNotificationChange}
                    sx={{
                      "& .MuiSwitch-switchBase.Mui-checked": {
                        color: "#f2674a",
                      },
                      "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                      {
                        bgcolor: "#f2674a",
                      },
                      "& .MuiSwitch-track": {
                        bgcolor: "rgba(255,255,255,0.4)",
                      },
                    }}
                  />
                </CardContent>
              </Card>
              <Card
                sx={{ height: "100px", width: "50%", padding: "20px" }}
                className="card"
              >
                <CardContent
                  sx={{
                    padding: "0px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Box>
                    <Typography
                      variant="h5"
                      fontWeight="bold"
                      className="text-white"
                    >
                      Enable Biometric
                    </Typography>
                    <Typography variant="subtitle1" className="text-white">
                      Enable/Disable Biometric
                    </Typography>
                  </Box>
                  <Switch
                    checked={biometricEnabled}
                    onChange={handleBiometricChange}
                    sx={{
                      "& .MuiSwitch-switchBase.Mui-checked": {
                        color: "#f2674a",
                      },
                      "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                      {
                        bgcolor: "#f2674a",
                      },
                      "& .MuiSwitch-track": {
                        bgcolor: "rgba(255,255,255,0.4)",
                      },
                    }}
                  />
                </CardContent>
              </Card>
            </Box>
            <Box
              display="flex"
              gap="20px"
              width="100%"
              alignItems="center"
              mb="20px"
            >
              <Card
                sx={{ height: "100px", width: "50%", padding: "20px" }}
                className="card"
              >
                <CardContent
                  sx={{
                    padding: "0px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Box>
                    <Typography
                      variant="h5"
                      fontWeight="bold"
                      className="text-white"
                    >
                      Change PIN
                    </Typography>
                    <Typography variant="subtitle1" className="text-white">
                      Need to update your PIN? Change it here.
                    </Typography>
                  </Box>
                  <IconButton onClick={handlepin}>
                    <ArrowForwardIos></ArrowForwardIos>
                  </IconButton>
                </CardContent>
              </Card>
              <Card
                sx={{ height: "100px", width: "50%", padding: "20px" }}
                className="card"
              >
                <CardContent
                  sx={{
                    padding: "0px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Box>
                    <Typography
                      variant="h5"
                      fontWeight="bold"
                      className="text-white"
                    >
                      Delete Account
                    </Typography>
                    <Typography variant="subtitle1" className="text-white">
                      Want to delete your account? Proceed here.
                    </Typography>
                  </Box>
                  <IconButton onClick={handleaccount}>
                    <ArrowForwardIos></ArrowForwardIos>
                  </IconButton>
                </CardContent>
              </Card>
            </Box>
            <Box
              display="flex"
              gap="20px"
              width="100%"
              alignItems="center"
              mb="20px"
            >
              <Card
                sx={{ height: "100px", width: "50%", padding: "20px" }}
                className="card"
              >
                <CardContent
                  sx={{
                    padding: "0px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Box>
                    <Typography
                      variant="h5"
                      fontWeight="bold"
                      className="text-white"
                    >
                      Enable Profile Access
                    </Typography>
                    <Typography variant="subtitle1" className="text-white">
                      Turn on to allow other users to view your watchlist and trades.
                    </Typography>
                  </Box>
                  <Switch
                    checked={profileAccessEnabled}
                    onChange={handleProfileAccessChange}
                    sx={{
                      "& .MuiSwitch-switchBase.Mui-checked": {
                        color: "#f2674a",
                      },
                      "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                      {
                        bgcolor: "#f2674a",
                      },
                      "& .MuiSwitch-track": {
                        bgcolor: "rgba(255,255,255,0.4)",
                      },
                    }}
                  />
                </CardContent>
              </Card>
            </Box>
          </Box>
        </Box>
      </Box>
      <Dialog
        open={changepin}
        onClose={handlepin}
        aria-labelledby="dialog-title"
        aria-describedby="dialog-description"
        // className="bg-color"

        PaperProps={{
          sx: {
            // boxShadow: "0px 0px 30px rgba(170, 170, 170, 0.7)",
            borderRadius: "20px",
            width: "620px",
            //   height:'376px',
            // width:'700px',
            border: "1px solid #FFFFFF1A",
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "20px 30px 10px 30px",
            mb: "0px",
          }}
        >
          <Typography className="text-white" fontWeight="bold" variant="h5">
            Change PIN
          </Typography>
          <IconButton onClick={handlepin}>
            <svg
              width="36"
              height="36"
              viewBox="0 0 36 36"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18 33C26.25 33 33 26.25 33 18C33 9.75 26.25 3 18 3C9.75 3 3 9.75 3 18C3 26.25 9.75 33 18 33Z"
                stroke="white"
                stroke-width="2.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M13.7549 22.2449L22.2449 13.7549"
                stroke="white"
                stroke-width="2.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M22.2449 22.2449L13.7549 13.7549"
                stroke="white"
                stroke-width="2.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </IconButton>
        </Box>
        <Divider sx={{ border: "1px solid #FFFFFF33" }}></Divider>

        <DialogContent
          sx={{
            padding: "20px 30px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <form onSubmit={formik.handleSubmit} style={{ width: "100%" }}>
            <Typography className="heading mb-10 text-secondary">
              <span>
                New Pin{" "}
                <sup>
                  <i
                    className="fa-solid fa-star-of-life"
                    style={{ color: "#fa0000", fontSize: "0.5rem" }}
                  ></i>
                </sup>
              </span>
            </Typography>
            <Box marginBottom="20px" className="otpgrp">
              {[1, 2, 3, 4].map((i) => {
                const inputName = `input_${i}` as keyof FormValues;

                return (
                  <TextField
                    key={i}
                    type={showPin ? "tel" : "password"}
                    inputProps={{
                      maxLength: 1,
                      pattern: "[0-9]*",
                      inputMode: "numeric",
                    }}
                    variant="outlined"
                    className="text-secondary "
                    inputRef={(el: any) => (inputRefs.current[i] = el)}
                    onKeyUp={(e: any) => {
                      if (!/[0-9]/.test(e.key) && e.key !== "Backspace") {
                        e.preventDefault();
                      } else {
                        handleKeyUp(e, i);
                      }
                    }}
                    onKeyDown={(e: React.KeyboardEvent) => {
                      if (!/[0-9]/.test(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    sx={{
                      ".css-j882ge-MuiInputBase-root-MuiOutlinedInput-root": {
                        width: "105px",
                        fontSize: "18px",
                      },
                      "& .MuiOutlinedInput-input": {
                        textAlign: "center",
                      },
                      " & .MuiOutlinedInput-notchedOutline": {
                        borderRadius: "123px",
                        borderColor: `${formik.errors[inputName] && isLogin
                          ? "red !important"
                          : " "
                          } `,
                      },
                    }}
                    size="medium"
                    InputLabelProps={{
                      shrink: false,
                      classes: {
                        focused: "focused-label",
                      },
                    }}
                    {...formik.getFieldProps(inputName)}
                  />
                );
              })}
            </Box>
            <Typography className="heading mb-10 text-secondary ">
              <span>
                Confirm Pin{" "}
                <sup>
                  <i
                    className="fa-solid fa-star-of-life"
                    style={{ color: "#fa0000", fontSize: "0.5rem" }}
                  ></i>
                </sup>
              </span>
            </Typography>
            <div className="otpgrp" style={{}}>
              {[1, 2, 3, 4].map((i) => {
                const inputName = `input_${i + 4}` as keyof FormValues;

                return (
                  <TextField
                    key={i}
                    type={showPin ? "tel" : "password"}
                    inputProps={{
                      maxLength: 1,
                      pattern: "[0-9]*",
                      inputMode: "numeric",
                    }}
                    variant="outlined"
                    className="text-secondary "
                    inputRef={(el: any) => (inputRefs.current[i + 4] = el)}
                    onKeyUp={(e: any) => {
                      if (!/[0-9]/.test(e.key) && e.key !== "Backspace") {
                        e.preventDefault();
                      } else {
                        handleKeyUp(e, i + 4);
                      }
                    }}
                    onKeyDown={(e: React.KeyboardEvent) => {
                      if (!/[0-9]/.test(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    sx={{
                      ".css-j882ge-MuiInputBase-root-MuiOutlinedInput-root": {
                        width: "105px !important",
                        height: "48px !important",
                        fontSize: "18px",
                      },
                      "& .MuiOutlinedInput-input": {
                        textAlign: "center",
                      },
                      " & .MuiOutlinedInput-notchedOutline": {
                        borderRadius: "123px",
                        borderColor: `${formik.errors[inputName] && isLogin
                          ? "red !important"
                          : " "
                          } `,
                      },
                    }}
                    size="medium"
                    InputLabelProps={{
                      shrink: false,
                      classes: {
                        focused: "focused-label",
                      },
                    }}
                    {...formik.getFieldProps(inputName)}
                  />
                );
              })}
            </div>
            <Divider
              sx={{ border: "1px solid #FFFFFF33", my: "20px" }}
            ></Divider>
            <Button
              //  sx={{marginTop:'20px'}}
              variant="contained"
              color="primary"
              fullWidth
              className="btn-primary fw-700 btn "
              sx={{ fontSize: "16px", padding: "13px 252px" }}
              endIcon={
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15 22C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22H15Z"
                    stroke="white"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M7.75 12L10.58 14.83L16.25 9.17004"
                    stroke="white"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              }
              type="submit"
            >
              Confirm
            </Button>
          </form>
        </DialogContent>
      </Dialog>

      <Dialog
        open={deleteaccount}
        onClose={handleaccount}
        aria-labelledby="dialog-title"
        aria-describedby="dialog-description"
        PaperProps={{
          sx: {
            borderRadius: "20px",
            minWidth: "700px",
            border: "1px solid #FFFFFF1A",
          },
        }}
      >
        <DialogContent sx={{ padding: "20px 30px" }}>
          <Box display="flex" justifyContent="end">
            <IconButton onClick={handleaccount}>
              <svg
                width="36"
                height="36"
                viewBox="0 0 36 36"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M18 33C26.25 33 33 26.25 33 18C33 9.75 26.25 3 18 3C9.75 3 3 9.75 3 18C3 26.25 9.75 33 18 33Z"
                  stroke="white"
                  stroke-width="2.25"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M13.7549 22.2449L22.2449 13.7549"
                  stroke="white"
                  stroke-width="2.25"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M22.2449 22.2449L13.7549 13.7549"
                  stroke="white"
                  stroke-width="2.25"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </IconButton>
          </Box>
          <Box mb="30px" display="flex" justifyContent="center">
            <svg
              width="340"
              height="250"
              viewBox="0 0 340 250"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M75.4818 68.9886L12.064 111.34L74.5272 204.567L137.945 162.215L75.4818 68.9886Z"
                fill="white"
                fill-opacity="0.1"
              />
              <path
                d="M105.176 157.803L104.456 162.25L72.9299 157.716L73.6494 153.27L105.176 157.803Z"
                fill="white"
                fill-opacity="0.1"
              />
              <path
                d="M89.2989 141.938L93.8227 142.589L88.8071 173.576L84.2827 172.926L89.2989 141.938Z"
                fill="white"
                fill-opacity="0.1"
              />
              <path
                d="M60.2603 102.552C60.3055 102.619 53.9499 106.942 46.067 112.206C38.1814 117.472 31.754 121.684 31.7087 121.617C31.6635 121.549 38.0175 117.227 45.9037 111.962C53.7865 106.698 60.2151 102.484 60.2603 102.552Z"
                fill="white"
                fill-opacity="0.1"
              />
              <path
                d="M83.583 96.7036C83.6282 96.7713 73.0595 103.907 59.9808 112.64C46.8971 121.377 36.2578 128.402 36.2125 128.335C36.1673 128.267 46.7337 121.132 59.8169 112.396C72.8956 103.663 83.5378 96.6365 83.583 96.7036Z"
                fill="white"
                fill-opacity="0.1"
              />
              <path
                d="M88.2578 103.684C88.303 103.752 77.7343 110.888 64.6556 119.621C51.5719 128.357 40.9326 135.383 40.8874 135.315C40.8421 135.247 51.4085 128.113 64.4917 119.377C77.571 110.644 88.2126 103.617 88.2578 103.684Z"
                fill="white"
                fill-opacity="0.1"
              />
              <path
                d="M92.9321 110.661C92.9773 110.728 82.4087 117.864 69.33 126.597C56.2462 135.334 45.6069 142.359 45.5617 142.292C45.5165 142.224 56.0828 135.089 69.1661 126.353C82.2453 117.62 92.8869 110.593 92.9321 110.661Z"
                fill="white"
                fill-opacity="0.1"
              />
              <path
                d="M97.6074 117.641C97.6526 117.709 87.0839 124.844 74.0053 133.578C60.9215 142.314 50.2822 149.34 50.237 149.272C50.1917 149.204 60.7581 142.07 73.8413 133.334C86.92 124.601 97.5622 117.574 97.6074 117.641Z"
                fill="white"
                fill-opacity="0.1"
              />
              <path
                d="M287.542 131.46L234.282 167.027L286.74 245.322L340 209.754L287.542 131.46Z"
                fill="white"
                fill-opacity="0.1"
              />
              <path
                d="M312.478 206.066L311.874 209.8L285.397 205.992L286.002 202.258L312.478 206.066Z"
                fill="white"
                fill-opacity="0.1"
              />
              <path
                d="M299.145 192.742L302.944 193.289L298.732 219.313L294.932 218.767L299.145 192.742Z"
                fill="white"
                fill-opacity="0.1"
              />
              <path
                d="M274.758 159.665C274.803 159.733 269.471 163.372 262.851 167.793C256.228 172.215 250.824 175.744 250.779 175.676C250.734 175.609 256.064 171.97 262.687 167.548C269.307 163.128 274.712 159.598 274.758 159.665Z"
                fill="white"
                fill-opacity="0.1"
              />
              <path
                d="M294.344 154.751C294.389 154.818 285.519 160.82 274.535 168.154C263.547 175.491 254.606 181.383 254.561 181.315C254.516 181.247 263.384 175.247 274.372 167.91C285.355 160.576 294.299 154.683 294.344 154.751Z"
                fill="white"
                fill-opacity="0.1"
              />
              <path
                d="M298.271 160.614C298.316 160.682 289.447 166.684 278.463 174.018C267.475 181.355 258.534 187.246 258.488 187.178C258.443 187.111 267.311 181.11 278.299 173.773C289.283 166.439 298.226 160.546 298.271 160.614Z"
                fill="white"
                fill-opacity="0.1"
              />
              <path
                d="M302.196 166.477C302.241 166.545 293.371 172.546 282.387 179.881C271.399 187.218 262.458 193.109 262.413 193.042C262.368 192.975 271.236 186.974 282.224 179.637C293.208 172.303 302.151 166.41 302.196 166.477Z"
                fill="white"
                fill-opacity="0.1"
              />
              <path
                d="M306.123 172.333C306.168 172.4 297.299 178.402 286.315 185.736C275.327 193.073 266.386 198.965 266.341 198.897C266.295 198.83 275.163 192.829 286.151 185.492C297.135 178.158 306.078 172.265 306.123 172.333Z"
                fill="white"
                fill-opacity="0.1"
              />
              <path
                d="M203.278 72.4112L145.165 41.3828L99.4017 126.811L157.514 157.839L203.278 72.4112Z"
                fill="white"
                fill-opacity="0.1"
              />
              <path
                d="M147.567 131.117L143.88 132.378L134.522 106.55L138.209 105.289L147.567 131.117Z"
                fill="white"
                fill-opacity="0.1"
              />
              <path
                d="M153.219 112.586L154.563 116.293L128.869 125.077L127.526 121.371L153.219 112.586Z"
                fill="white"
                fill-opacity="0.1"
              />
              <path
                d="M171.476 74.4827C171.43 74.5679 165.536 71.509 158.312 67.6524C151.086 63.794 145.267 60.5986 145.313 60.5134C145.358 60.4288 151.251 63.4865 158.477 67.3443C165.701 71.2015 171.521 74.398 171.476 74.4827Z"
                fill="white"
                fill-opacity="0.1"
              />
              <path
                d="M185.422 89.8491C185.376 89.9343 175.621 84.8142 163.637 78.4156C151.648 72.0141 141.969 66.7581 142.014 66.6729C142.06 66.5883 151.813 71.7066 163.802 78.1081C175.786 84.5067 185.467 89.7639 185.422 89.8491Z"
                fill="white"
                fill-opacity="0.1"
              />
              <path
                d="M181.996 96.2364C181.95 96.3216 172.195 91.2015 160.211 84.8023C148.222 78.4009 138.543 73.1448 138.588 73.0596C138.634 72.975 148.387 78.0933 160.376 84.4948C172.36 90.8934 182.041 96.1512 181.996 96.2364Z"
                fill="white"
                fill-opacity="0.1"
              />
              <path
                d="M178.571 102.631C178.525 102.716 168.77 97.5961 156.786 91.1969C144.797 84.796 135.118 79.5394 135.163 79.4542C135.209 79.369 144.962 84.4879 156.951 90.8893C168.935 97.2885 178.617 102.546 178.571 102.631Z"
                fill="white"
                fill-opacity="0.1"
              />
              <path
                d="M175.145 109.022C175.099 109.107 165.345 103.987 153.36 97.5875C141.371 91.1866 131.692 85.93 131.738 85.8448C131.784 85.7601 141.536 90.8785 153.525 97.2799C165.51 103.679 175.19 108.937 175.145 109.022Z"
                fill="white"
                fill-opacity="0.1"
              />
              <path
                opacity="0.2"
                d="M175.449 0H173.989V24.8176H175.449V0Z"
                fill="#141414"
              />
              <path
                d="M140.678 54.8494H208.762C208.762 54.8494 202.476 24.8125 174.204 24.8125C149.057 24.8119 140.678 54.8494 140.678 54.8494Z"
                fill="#4EDF6D"
              />
              <path
                d="M175.45 0H173.99V24.8176H175.45V0Z"
                fill="white"
                fill-opacity="0.2"
              />
              <path
                d="M326.308 248.178C326.308 248.259 253.255 248.325 163.162 248.325C73.0366 248.325 0 248.259 0 248.178C0 248.097 73.0366 248.031 163.162 248.031C253.255 248.031 326.308 248.097 326.308 248.178Z"
                fill="white"
              />
              <path
                d="M18.0589 212.836C19.9698 212.903 21.7638 213.939 23.0241 215.375C24.2845 216.81 25.0572 218.615 25.5517 220.46C26.508 224.027 25.9202 228.238 24.9012 231.789C21.0318 230.408 18.6461 226.289 17.5672 224.123C15.8614 220.7 14.8616 213.48 18.0589 212.836Z"
                fill="#4EDF6D"
              />
              <path
                d="M30.4686 236.111C29.2478 234.362 29.219 231.928 30.1843 230.025C31.1491 228.123 33.0035 226.751 35.0456 226.125C35.99 225.835 37.0854 225.713 37.9066 226.261C38.6747 226.773 39.0065 227.778 38.907 228.694C38.8081 229.611 38.343 230.45 37.7942 231.191C35.9126 233.734 33.6241 235.85 30.4686 236.111Z"
                fill="#4EDF6D"
              />
              <path
                d="M30.8936 248.039C30.8749 248.041 30.8161 247.777 30.7206 247.297C30.6172 246.768 30.4832 246.085 30.3227 245.264C30.0175 243.554 29.5331 241.123 29.8994 238.434C30.2515 235.758 31.3186 233.471 32.4371 232.105C32.9876 231.413 33.515 230.924 33.905 230.623C34.0937 230.465 34.2599 230.368 34.3656 230.293C34.4735 230.222 34.5329 230.189 34.5385 230.196C34.5809 230.244 33.6342 230.827 32.588 232.22C31.5283 233.59 30.5126 235.839 30.1656 238.47C29.805 241.103 30.2515 243.513 30.5098 245.231C30.6483 246.095 30.7596 246.794 30.8241 247.28C30.8879 247.766 30.9117 248.036 30.8936 248.039Z"
                fill="#141414"
              />
              <path
                d="M19.3064 218.27C19.3149 218.266 19.3685 218.367 19.4624 218.562C19.5652 218.784 19.6975 219.069 19.8608 219.422C20.2028 220.171 20.6832 221.26 21.2659 222.612C22.4319 225.314 23.9896 229.07 25.6162 233.256C27.2423 237.443 28.6282 241.266 29.5919 244.046C30.0745 245.437 30.4549 246.565 30.7081 247.348C30.8257 247.719 30.9206 248.018 30.9941 248.251C31.0569 248.459 31.0851 248.569 31.0766 248.572C31.0676 248.575 31.0224 248.471 30.9432 248.269C30.8573 248.04 30.7466 247.746 30.6098 247.382C30.3159 246.578 29.9101 245.468 29.4133 244.11C28.4038 241.347 26.9908 237.537 25.3659 233.352C23.7404 229.169 22.2109 225.405 21.0907 222.685C20.5402 221.348 20.0903 220.255 19.7642 219.463C19.6195 219.102 19.5025 218.811 19.4115 218.583C19.3346 218.381 19.2979 218.274 19.3064 218.27Z"
                fill="#141414"
              />
              <path
                d="M26.301 240.146C24.0193 236.27 19.7588 233.627 15.2672 233.302C14.1232 233.219 12.7475 233.412 12.2377 234.437C11.7268 235.464 12.4101 236.68 13.1895 237.522C16.4315 241.028 21.9162 242.25 26.344 240.454"
                fill="#4EDF6D"
              />
              <path
                d="M17.0093 236.361C17.0104 236.342 17.2648 236.353 17.7254 236.387C17.956 236.403 18.238 236.423 18.5608 236.484C18.8829 236.543 19.2577 236.578 19.6567 236.69C20.0586 236.788 20.5017 236.886 20.9606 237.051C21.4286 237.19 21.909 237.389 22.4137 237.603C23.4107 238.054 24.4682 238.646 25.4754 239.415C26.4753 240.193 27.3197 241.063 28.0064 241.915C28.3364 242.352 28.6518 242.767 28.8977 243.188C29.1695 243.592 29.3713 243.999 29.5607 244.366C29.7636 244.726 29.8834 245.083 30.0162 245.382C30.1502 245.682 30.2338 245.952 30.3005 246.173C30.4379 246.614 30.5045 246.859 30.487 246.864C30.4299 246.883 30.1547 245.897 29.3928 244.453C29.195 244.095 28.9864 243.7 28.7106 243.307C28.4608 242.897 28.1432 242.495 27.8136 242.069C27.1275 241.239 26.2938 240.391 25.3121 239.627C24.323 238.872 23.2881 238.285 22.312 237.828C21.818 237.612 21.3478 237.407 20.8894 237.262C20.4406 237.09 20.0054 236.983 19.6115 236.874C18.0261 236.473 17.0031 236.419 17.0093 236.361Z"
                fill="#141414"
              />
              <path
                d="M273.571 59.5191C271.909 59.9011 271.1 61.81 270.942 63.5056C270.784 65.2007 271.001 66.9911 270.288 68.5378C269.485 70.2786 267.568 71.5617 267.504 73.4774C267.465 74.6449 268.16 75.743 268.127 76.911C268.072 78.829 266.113 80.2786 266.01 82.1948C265.936 83.5745 266.856 84.8988 266.635 86.2627C266.463 87.324 265.635 88.1603 265.286 89.1771C264.588 91.2045 265.983 93.4362 267.8 94.5772C269.825 95.849 272.418 96.1769 274.697 95.4501C276.976 94.7233 278.898 92.9543 279.809 90.7463C280.814 88.3093 280.594 85.5652 280.376 82.9391C279.695 74.7538 279.189 66.5544 278.858 58.3477"
                fill="#262626"
              />
              <path
                d="M268.746 88.403C268.71 88.3708 269.2 88.2252 269.506 87.5013C269.653 87.1475 269.729 86.6713 269.699 86.124C269.68 85.5733 269.491 84.9734 269.287 84.2969C269.098 83.6266 268.851 82.8485 268.992 81.9835C269.134 81.1049 269.764 80.3832 270.339 79.6745C270.628 79.3151 270.919 78.9416 271.102 78.5167C271.295 78.0963 271.336 77.615 271.19 77.1636C270.898 76.2416 269.993 75.5634 269.578 74.4992C269.372 73.966 269.37 73.3803 269.487 72.8527C269.599 72.3201 269.815 71.8365 270.032 71.3761C270.475 70.4575 270.962 69.615 271.155 68.7207C271.552 66.9309 271.367 65.2223 271.637 63.819C271.882 62.4129 272.477 61.356 273.066 60.8127C273.354 60.5317 273.632 60.3821 273.813 60.2811C274.006 60.1982 274.108 60.1598 274.112 60.1694C274.131 60.201 273.693 60.3353 273.147 60.8934C272.602 61.4435 272.056 62.4772 271.842 63.8534C271.73 64.5379 271.713 65.3075 271.685 66.1336C271.656 66.9591 271.63 67.8557 271.419 68.7822C271.223 69.7211 270.722 70.5968 270.293 71.4991C269.868 72.3855 269.477 73.4249 269.853 74.3965C270.212 75.3569 271.123 76.0391 271.465 77.0767C271.632 77.593 271.577 78.1652 271.359 78.6278C271.151 79.0984 270.843 79.4833 270.548 79.8444C269.958 80.5576 269.367 81.2358 269.231 82.0258C269.09 82.8112 269.308 83.569 269.486 84.2399C269.676 84.9108 269.858 85.5428 269.863 86.1166C269.878 86.6854 269.782 87.1808 269.61 87.547C269.44 87.9155 269.206 88.1434 269.031 88.2591C268.857 88.3782 268.746 88.403 268.746 88.403Z"
                fill="#455A64"
              />
              <path
                d="M264.296 101.777L259.194 116.46L237.918 117.599L234.37 125.481L256.582 127.724C261.012 129.552 266.073 127.312 267.689 122.807L273.617 106.289L264.296 101.777Z"
                fill="#FFD1CA"
              />
              <path
                d="M308.304 240.208C308.304 240.208 292.713 190.769 292.382 189.163C292.083 187.712 298.04 152.134 298.791 142.926L277.724 143.71C277.724 143.71 277.723 143.767 277.722 143.864L268.767 144.36L276.788 245.473H286.482L285.521 211.926C291.499 227.95 300.066 244.279 300.066 244.279L308.304 240.208Z"
                fill="#FFD1CA"
              />
              <path
                d="M285.916 223.954C285.924 223.647 285.798 212.714 285.798 212.714C285.677 213.368 282.082 203.222 282.169 202.605C282.213 202.286 285.916 223.954 285.916 223.954Z"
                fill="black"
                fill-opacity="0.1"
              />
              <path
                d="M281.758 197.801C281.736 197.8 281.716 198.018 281.696 198.414C281.675 198.809 281.671 199.382 281.709 200.09C281.723 200.444 281.76 200.831 281.806 201.246C281.859 201.66 281.916 202.103 282.012 202.563C282.187 203.486 282.459 204.484 282.804 205.508C283.508 207.553 284.285 209.343 284.837 210.641C285.098 211.233 285.323 211.742 285.511 212.17C285.677 212.528 285.778 212.722 285.799 212.714C285.82 212.706 285.758 212.496 285.628 212.123C285.498 211.75 285.3 211.214 285.048 210.556C284.551 209.236 283.807 207.433 283.11 205.406C282.768 204.392 282.492 203.411 282.303 202.505C282.201 202.054 282.135 201.619 282.072 201.212C282.015 200.804 281.965 200.423 281.938 200.074C281.871 199.376 281.84 198.807 281.823 198.414C281.802 198.019 281.78 197.801 281.758 197.801Z"
                fill="black"
                fill-opacity="0.1"
              />
              <path
                d="M276.605 245.966L276.601 245.057L286.532 244.625L286.559 248.374L285.946 248.416C283.22 248.575 272.075 249.034 270.251 248.488C268.216 247.879 276.605 245.966 276.605 245.966Z"
                fill="#262626"
              />
              <path
                d="M286.696 248.154C286.696 248.158 286.638 248.165 286.527 248.173C286.38 248.183 286.22 248.193 286.039 248.204C285.551 248.227 284.952 248.255 284.243 248.288C282.727 248.348 280.631 248.403 278.315 248.413C275.998 248.423 273.901 248.386 272.385 248.34C271.677 248.313 271.077 248.29 270.589 248.271C270.408 248.261 270.247 248.253 270.101 248.244C269.99 248.237 269.931 248.231 269.931 248.227C269.931 248.223 269.99 248.221 270.102 248.22C270.249 248.221 270.41 248.223 270.591 248.225C271.079 248.233 271.679 248.243 272.387 248.255C273.904 248.279 276 248.303 278.315 248.293C280.629 248.283 282.725 248.241 284.241 248.203C284.949 248.185 285.55 248.169 286.037 248.157C286.219 248.154 286.379 248.151 286.526 248.148C286.638 248.148 286.696 248.15 286.696 248.154Z"
                fill="white"
              />
              <path
                d="M273.387 248.467C273.35 248.472 273.321 248.044 273.048 247.613C272.783 247.177 272.413 246.959 272.434 246.929C272.441 246.899 272.865 247.083 273.151 247.55C273.441 248.013 273.417 248.474 273.387 248.467Z"
                fill="white"
              />
              <path
                d="M276.297 246.985C276.269 247.002 276.129 246.833 275.985 246.607C275.84 246.381 275.745 246.183 275.773 246.165C275.801 246.147 275.941 246.317 276.086 246.543C276.23 246.769 276.324 246.967 276.297 246.985Z"
                fill="white"
              />
              <path
                d="M277.095 246.554C277.073 246.579 276.917 246.476 276.745 246.324C276.575 246.171 276.454 246.029 276.476 246.004C276.498 245.979 276.654 246.082 276.825 246.234C276.996 246.387 277.117 246.53 277.095 246.554Z"
                fill="white"
              />
              <path
                d="M277.598 245.623C277.598 245.656 277.368 245.686 277.082 245.69C276.797 245.694 276.566 245.671 276.565 245.638C276.564 245.605 276.795 245.575 277.08 245.571C277.366 245.567 277.597 245.59 277.598 245.623Z"
                fill="white"
              />
              <path
                d="M277.769 244.971C277.78 245 277.529 245.114 277.194 245.14C276.859 245.168 276.593 245.094 276.6 245.063C276.605 245.029 276.866 245.047 277.185 245.021C277.502 244.997 277.758 244.938 277.769 244.971Z"
                fill="white"
              />
              <path
                d="M275.959 246.121C275.96 246.134 275.716 246.165 275.324 246.119C275.129 246.097 274.897 246.051 274.648 245.973C274.524 245.93 274.394 245.897 274.26 245.815C274.198 245.773 274.128 245.715 274.103 245.619C274.076 245.524 274.126 245.417 274.198 245.365C274.804 245.049 275.413 245.387 275.639 245.699C275.764 245.858 275.821 246.014 275.848 246.121C275.874 246.23 275.872 246.292 275.865 246.292C275.842 246.301 275.821 246.043 275.574 245.753C275.452 245.611 275.268 245.472 275.03 245.403C274.806 245.338 274.486 245.321 274.273 245.457C274.173 245.532 274.212 245.65 274.325 245.717C274.429 245.784 274.565 245.824 274.682 245.867C274.923 245.949 275.147 246.002 275.336 246.035C275.717 246.102 275.959 246.102 275.959 246.121Z"
                fill="white"
              />
              <path
                d="M275.794 246.158C275.785 246.165 275.691 246.004 275.72 245.719C275.735 245.579 275.785 245.413 275.892 245.255C276.003 245.114 276.147 244.919 276.419 244.93C276.566 244.949 276.639 245.115 276.616 245.222C276.604 245.333 276.555 245.428 276.509 245.506C276.415 245.664 276.309 245.793 276.21 245.89C276.012 246.085 275.855 246.16 275.848 246.148C275.837 246.133 275.974 246.034 276.148 245.833C276.235 245.732 276.329 245.605 276.413 245.451C276.499 245.317 276.558 245.076 276.399 245.048C276.24 245.033 276.078 245.192 275.981 245.319C275.882 245.457 275.827 245.604 275.803 245.732C275.756 245.989 275.816 246.154 275.794 246.158Z"
                fill="white"
              />
              <path
                d="M286.486 245.454C286.483 245.476 286.202 245.428 285.757 245.483C285.315 245.533 284.7 245.717 284.166 246.144C283.633 246.572 283.321 247.131 283.176 247.552C283.027 247.975 283.013 248.259 282.99 248.256C282.983 248.256 282.979 248.185 282.989 248.057C282.999 247.93 283.029 247.745 283.095 247.525C283.223 247.087 283.535 246.497 284.091 246.051C284.647 245.606 285.291 245.429 285.747 245.399C285.977 245.382 286.164 245.393 286.291 245.411C286.418 245.428 286.487 245.447 286.486 245.454Z"
                fill="white"
              />
              <path
                d="M281.729 247.364C281.733 247.395 281.089 247.498 280.286 247.501C279.483 247.507 278.838 247.411 278.842 247.38C278.845 247.345 279.49 247.387 280.286 247.381C281.081 247.378 281.725 247.329 281.729 247.364Z"
                fill="white"
              />
              <path
                d="M283.664 247.348C283.689 247.372 283.612 247.484 283.547 247.632C283.48 247.78 283.447 247.912 283.412 247.91C283.38 247.91 283.361 247.754 283.438 247.583C283.514 247.412 283.643 247.324 283.664 247.348Z"
                fill="white"
              />
              <path
                d="M284.391 246.438C284.415 246.461 284.352 246.564 284.25 246.668C284.149 246.772 284.047 246.837 284.023 246.814C284 246.791 284.063 246.688 284.165 246.584C284.266 246.481 284.367 246.415 284.391 246.438Z"
                fill="white"
              />
              <path
                d="M285.433 246.016C285.426 246.05 285.296 246.049 285.151 246.101C285.004 246.149 284.902 246.23 284.876 246.208C284.849 246.19 284.932 246.049 285.112 245.988C285.292 245.926 285.443 245.986 285.433 246.016Z"
                fill="white"
              />
              <path
                d="M286.177 245.815C286.189 245.846 286.132 245.897 286.05 245.929C285.968 245.961 285.892 245.962 285.88 245.931C285.869 245.9 285.925 245.849 286.007 245.817C286.089 245.786 286.164 245.785 286.177 245.815Z"
                fill="white"
              />
              <path
                d="M299.869 245.091L299.492 244.263L308.374 239.809L309.938 243.218L309.396 243.506C306.974 244.766 296.995 249.742 295.107 249.99C293.001 250.266 299.869 245.091 299.869 245.091Z"
                fill="#262626"
              />
              <path
                d="M309.971 242.957C309.973 242.961 309.923 242.991 309.824 243.044C309.695 243.113 309.552 243.188 309.392 243.272C308.956 243.492 308.42 243.763 307.788 244.083C306.43 244.758 304.54 245.665 302.431 246.622C300.322 247.578 298.394 248.402 296.991 248.98C296.335 249.245 295.778 249.47 295.325 249.652C295.156 249.717 295.006 249.775 294.869 249.827C294.765 249.866 294.709 249.885 294.707 249.881C294.705 249.877 294.758 249.851 294.86 249.805C294.995 249.747 295.141 249.682 295.308 249.609C295.756 249.417 296.308 249.181 296.959 248.902C298.353 248.305 300.274 247.469 302.382 246.513C304.489 245.558 306.384 244.663 307.752 244.008C308.39 243.702 308.931 243.442 309.371 243.231C309.535 243.154 309.681 243.086 309.813 243.023C309.915 242.977 309.969 242.954 309.971 242.957Z"
                fill="white"
              />
              <path
                d="M297.961 248.691C297.93 248.711 297.727 248.333 297.301 248.05C296.881 247.761 296.454 247.714 296.46 247.677C296.454 247.647 296.916 247.642 297.369 247.951C297.824 248.255 297.991 248.686 297.961 248.691Z"
                fill="white"
              />
              <path
                d="M300.005 246.142C299.987 246.17 299.79 246.073 299.565 245.926C299.34 245.779 299.172 245.637 299.19 245.61C299.208 245.583 299.406 245.68 299.631 245.826C299.856 245.973 300.023 246.115 300.005 246.142Z"
                fill="white"
              />
              <path
                d="M300.559 245.426C300.549 245.458 300.364 245.427 300.146 245.358C299.928 245.289 299.759 245.208 299.769 245.177C299.779 245.145 299.964 245.175 300.182 245.244C300.4 245.313 300.569 245.394 300.559 245.426Z"
                fill="white"
              />
              <path
                d="M300.635 244.374C300.649 244.404 300.45 244.526 300.193 244.646C299.934 244.767 299.713 244.84 299.7 244.81C299.686 244.78 299.884 244.658 300.142 244.538C300.399 244.417 300.62 244.344 300.635 244.374Z"
                fill="white"
              />
              <path
                d="M300.521 243.702C300.543 243.724 300.361 243.931 300.066 244.091C299.772 244.253 299.499 244.295 299.492 244.264C299.483 244.231 299.729 244.14 300.008 243.986C300.289 243.835 300.498 243.677 300.521 243.702Z"
                fill="white"
              />
              <path
                d="M299.344 245.496C299.35 245.508 299.141 245.636 298.764 245.754C298.577 245.813 298.347 245.866 298.087 245.897C297.956 245.908 297.825 245.932 297.669 245.912C297.594 245.9 297.507 245.875 297.444 245.798C297.381 245.722 297.383 245.604 297.427 245.527C297.85 244.991 298.545 245.051 298.879 245.243C299.059 245.338 299.175 245.456 299.243 245.543C299.311 245.631 299.334 245.689 299.329 245.692C299.312 245.709 299.186 245.483 298.842 245.319C298.672 245.239 298.447 245.188 298.202 245.222C297.971 245.254 297.673 245.369 297.534 245.581C297.473 245.69 297.558 245.782 297.687 245.796C297.811 245.814 297.95 245.796 298.075 245.788C298.328 245.764 298.554 245.721 298.741 245.673C299.115 245.577 299.336 245.478 299.344 245.496Z"
                fill="white"
              />
              <path
                d="M299.207 245.596C299.202 245.606 299.05 245.497 298.959 245.225C298.915 245.091 298.893 244.918 298.925 244.732C298.969 244.557 299.02 244.321 299.272 244.219C299.414 244.176 299.745 244.46 299.768 244.567C299.804 244.674 299.601 244.619 299.59 244.708C299.57 244.891 299.526 245.052 299.476 245.181C299.375 245.44 299.262 245.572 299.251 245.565C299.234 245.555 299.319 245.409 299.396 245.154C299.433 245.026 299.467 244.872 299.48 244.698C299.504 244.54 299.459 244.296 299.302 244.336C299.151 244.387 299.069 244.598 299.033 244.753C298.999 244.919 299.009 245.076 299.039 245.203C299.103 245.457 299.225 245.583 299.207 245.596Z"
                fill="white"
              />
              <path
                d="M308.671 240.58C308.679 240.601 308.402 240.672 308.017 240.904C307.635 241.131 307.149 241.549 306.838 242.157C306.527 242.765 306.472 243.404 306.512 243.846C306.549 244.293 306.654 244.558 306.633 244.565C306.626 244.568 306.593 244.504 306.55 244.384C306.507 244.263 306.459 244.083 306.428 243.855C306.365 243.403 306.407 242.737 306.731 242.103C307.056 241.469 307.571 241.045 307.975 240.831C308.178 240.721 308.353 240.655 308.476 240.619C308.599 240.584 308.669 240.573 308.671 240.58Z"
                fill="white"
              />
              <path
                d="M305.117 244.272C305.133 244.298 304.587 244.655 303.857 244.987C303.126 245.32 302.499 245.496 302.489 245.467C302.478 245.434 303.084 245.208 303.807 244.878C304.531 244.55 305.099 244.241 305.117 244.272Z"
                fill="white"
              />
              <path
                d="M306.874 243.458C306.906 243.47 306.883 243.604 306.884 243.766C306.883 243.928 306.906 244.062 306.874 244.074C306.845 244.087 306.764 243.953 306.764 243.766C306.764 243.579 306.845 243.445 306.874 243.458Z"
                fill="white"
              />
              <path
                d="M307.164 242.337C307.195 242.348 307.179 242.468 307.129 242.604C307.079 242.741 307.013 242.842 306.982 242.831C306.951 242.819 306.967 242.7 307.017 242.563C307.067 242.427 307.133 242.326 307.164 242.337Z"
                fill="white"
              />
              <path
                d="M307.943 241.524C307.95 241.557 307.83 241.61 307.719 241.716C307.606 241.82 307.545 241.936 307.512 241.926C307.481 241.921 307.498 241.759 307.637 241.629C307.776 241.499 307.939 241.492 307.943 241.524Z"
                fill="white"
              />
              <path
                d="M308.54 241.039C308.564 241.062 308.532 241.131 308.472 241.194C308.41 241.257 308.341 241.289 308.318 241.266C308.294 241.242 308.325 241.173 308.386 241.11C308.447 241.048 308.516 241.016 308.54 241.039Z"
                fill="white"
              />
              <path
                d="M297.424 126.178L295.77 106.035L304.264 106.186C304.264 106.186 304.657 103.216 303.406 96.7014C302.638 92.7064 299.973 90.2563 296.985 88.8005L296.985 88.7469L296.726 88.6792C292.925 86.9029 288.946 86.6523 288.946 86.6523L278.52 86.7725C278.52 86.7725 270.555 85.7806 266.146 91.4492C264.448 93.6329 259.193 108.578 259.193 108.578L271.708 114.594L270.516 106.307C270.516 106.307 270.753 112.316 271.521 114.22C271.949 115.281 273.188 118.574 273.188 118.574L273.026 128.513L297.424 126.178Z"
                fill="#F2674A"
              />
              <path
                d="M291.672 103.125L290.124 109.708H304.724L303.764 98.6719L291.672 103.125Z"
                fill="#F2674A"
              />
              <path
                d="M304.723 109.707C304.726 109.663 303.988 109.586 302.791 109.516C301.594 109.446 299.939 109.387 298.109 109.395C296.279 109.404 294.623 109.483 293.427 109.578C292.232 109.672 291.497 109.773 291.5 109.816C291.503 109.862 292.244 109.841 293.44 109.805C294.635 109.768 296.286 109.725 298.111 109.716C299.935 109.709 301.587 109.731 302.784 109.743C303.98 109.755 304.721 109.752 304.723 109.707Z"
                fill="white"
              />
              <path
                d="M291.042 98.6133C290.998 98.615 290.982 99.2548 290.994 100.287C291.005 101.321 291.042 102.746 291.103 104.32C291.164 105.894 291.237 107.319 291.307 108.35C291.376 109.38 291.441 110.017 291.485 110.015C291.53 110.013 291.545 109.374 291.534 108.341C291.523 107.308 291.485 105.882 291.424 104.308C291.363 102.733 291.29 101.309 291.22 100.278C291.152 99.2486 291.087 98.6116 291.042 98.6133Z"
                fill="white"
              />
              <g opacity="0.3">
                <path
                  d="M277.757 104.316C277.757 104.316 281.002 128.336 290.124 127.7C290.124 127.7 294.231 127.651 295.552 124.926V123.853L277.757 104.316Z"
                  fill="#141414"
                />
              </g>
              <g opacity="0.3">
                <path
                  d="M291.042 100.031L289.296 111.806L290.427 113.872L292.288 109.832L291.5 109.814L291.042 100.031Z"
                  fill="white"
                />
              </g>
              <path
                d="M273.189 118.586C273.17 118.593 273.083 118.392 272.943 118.024C272.801 117.656 272.613 117.117 272.395 116.447C271.959 115.107 271.42 113.23 270.999 111.118C270.579 109.004 270.373 107.059 270.307 105.65C270.273 104.945 270.262 104.374 270.273 103.979C270.281 103.585 270.294 103.367 270.315 103.367C270.362 103.367 270.393 104.237 270.514 105.635C270.634 107.034 270.87 108.96 271.287 111.061C271.706 113.16 272.21 115.035 272.594 116.387C272.773 117.014 272.926 117.549 273.052 117.989C273.158 118.367 273.208 118.579 273.189 118.586Z"
                fill="white"
              />
              <path
                d="M276.878 125.494C276.8 125.518 276.574 124.999 276.373 124.337C276.173 123.674 276.073 123.118 276.151 123.095C276.229 123.071 276.454 123.589 276.655 124.252C276.856 124.914 276.956 125.471 276.878 125.494Z"
                fill="white"
              />
              <path
                d="M278.138 125.4C278.063 125.419 277.817 124.642 277.805 123.644C277.788 122.647 278.011 121.862 278.086 121.879C278.17 121.894 278.082 122.677 278.099 123.64C278.11 124.602 278.222 125.383 278.138 125.4Z"
                fill="white"
              />
              <path
                d="M271.963 114.88C271.926 114.953 269.014 113.574 265.458 111.8C261.901 110.025 259.048 108.529 259.085 108.456C259.121 108.383 262.033 109.763 265.59 111.537C269.145 113.311 271.999 114.808 271.963 114.88Z"
                fill="white"
              />
              <path
                d="M277.095 88.7398C277.16 85.8853 277.176 82.8789 277.176 82.8789C277.176 82.8789 273.508 82.1736 272.869 77.356C272.26 72.7618 273.964 61.9818 273.964 61.9818C279.321 59.96 284.889 61.7927 288.559 66.1262L287.648 89.3024C287.542 91.9927 285.141 94.0449 282.256 93.9101C279.342 93.7735 277.032 91.4595 277.095 88.7398Z"
                fill="#FFD1CA"
              />
              <path
                d="M273.686 70.5878C273.666 70.9123 273.925 71.1966 274.264 71.2237C274.603 71.2508 274.894 71.0099 274.914 70.6854C274.934 70.361 274.675 70.076 274.336 70.0489C273.997 70.0219 273.706 70.2634 273.686 70.5878Z"
                fill="#141414"
              />
              <path
                d="M273.457 69.7728C273.531 69.8552 274.007 69.5222 274.67 69.5409C275.333 69.5499 275.811 69.9031 275.885 69.8241C275.921 69.7891 275.847 69.6424 275.639 69.4827C275.434 69.3242 275.082 69.1656 274.669 69.1566C274.256 69.1481 273.904 69.2909 273.701 69.4416C273.493 69.5928 273.42 69.7361 273.457 69.7728Z"
                fill="#141414"
              />
              <path
                d="M280.414 71.0092C280.395 71.3337 280.653 71.6186 280.993 71.6457C281.331 71.6728 281.622 71.4318 281.642 71.1074C281.662 70.7829 281.403 70.498 281.064 70.4709C280.725 70.4433 280.434 70.6848 280.414 71.0092Z"
                fill="#141414"
              />
              <path
                d="M280.371 70.1946C280.445 70.277 280.922 69.9441 281.584 69.9627C282.247 69.9723 282.725 70.3256 282.799 70.246C282.835 70.211 282.762 70.0643 282.553 69.9046C282.348 69.7461 281.996 69.5875 281.583 69.5785C281.17 69.57 280.818 69.7128 280.615 69.8634C280.407 70.0147 280.335 70.158 280.371 70.1946Z"
                fill="#141414"
              />
              <path
                d="M277.836 75.0444C277.84 75.0066 277.43 74.9253 276.764 74.8227C276.595 74.8006 276.436 74.7634 276.41 74.6472C276.374 74.5242 276.449 74.3436 276.536 74.1489C276.706 73.7438 276.884 73.3195 277.07 72.8743C277.813 71.0591 278.356 69.5649 278.282 69.5356C278.209 69.5063 277.547 70.9536 276.804 72.7688C276.625 73.2162 276.454 73.6434 276.291 74.0513C276.222 74.242 276.106 74.457 276.186 74.7126C276.228 74.8401 276.35 74.9349 276.458 74.9671C276.566 75.0032 276.661 75.0072 276.744 75.0145C277.416 75.0687 277.833 75.0822 277.836 75.0444Z"
                fill="#141414"
              />
              <path
                d="M277.175 82.8764C277.175 82.8764 280.403 83.1676 283.655 81.3281C283.655 81.3281 282.009 84.5839 277.21 84.0106L277.175 82.8764Z"
                fill="black"
                fill-opacity="0.1"
              />
              <path
                d="M282.493 68.3026C282.357 68.5097 281.853 68.4177 281.287 68.3161C280.725 68.2027 280.221 68.1029 280.171 67.8602C280.115 67.6278 280.699 67.3056 281.453 67.45C282.207 67.5933 282.631 68.1068 282.493 68.3026Z"
                fill="#141414"
              />
              <path
                d="M275.899 67.3266C275.848 67.5681 275.308 67.6561 274.685 67.6877C274.062 67.7131 273.516 67.6747 273.443 67.4394C273.368 67.2115 273.895 66.8402 274.645 66.8075C275.394 66.7714 275.953 67.0924 275.899 67.3266Z"
                fill="#141414"
              />
              <path
                d="M277.847 76.639C277.707 76.6 277.55 76.6796 277.48 76.8065C277.396 76.9572 277.435 77.1648 277.567 77.276C277.699 77.3872 277.91 77.39 278.045 77.2822C278.18 77.175 278.224 76.9685 278.145 76.8156C278.066 76.6627 277.872 76.5791 277.706 76.6265"
                fill="black"
                fill-opacity="0.1"
              />
              <path
                d="M278.002 76.6989C278.032 76.6724 277.896 76.5099 277.606 76.5731C277.472 76.6024 277.297 76.7226 277.244 76.928C277.191 77.121 277.239 77.3709 277.444 77.5278C277.656 77.6768 277.911 77.6463 278.079 77.5317C278.26 77.4132 278.311 77.1966 278.283 77.0612C278.225 76.7638 278.004 76.7164 277.998 76.7576C277.973 76.7948 278.075 76.8981 278.055 77.0741C278.046 77.1605 278.004 77.2406 277.921 77.2812C277.839 77.3258 277.708 77.3258 277.634 77.2688C277.557 77.2135 277.517 77.0905 277.532 76.9957C277.544 76.9009 277.608 76.8304 277.684 76.7869C277.842 76.6978 277.981 76.7395 278.002 76.6989Z"
                fill="#141414"
              />
              <path
                d="M286.337 71.7916C285.765 73.1143 284.37 74.1334 284.564 75.561C284.689 76.4824 285.281 77.3418 285.166 78.2649C285.021 79.424 283.815 80.2275 283.644 81.3831C283.435 82.8005 284.816 83.902 285.367 85.2247C286.171 87.1505 285.143 89.3167 285.119 91.4028C285.082 94.5983 287.803 97.5833 290.993 97.8457C292.284 97.9518 293.738 97.563 294.406 96.4565C294.958 95.5435 294.848 94.3833 295.179 93.3693C295.672 91.8593 297.113 90.7539 297.418 89.1949C297.971 86.3526 294.531 84.0008 294.757 81.1139C294.854 79.8805 295.617 78.8044 295.941 77.6104C296.366 76.0462 295.976 74.2846 294.931 73.0443C294.082 72.036 292.85 71.373 292.127 70.2715C291.307 69.0222 291.279 67.4383 290.97 65.9768C290.216 62.4157 287.537 59.3224 284.117 58.063C280.696 56.8035 276.647 57.4197 273.758 59.639C273.758 59.639 272.935 63.3581 276.76 63.9799C280.583 64.6017 282.356 63.884 282.787 65.4143C282.787 65.4143 282.351 67.2013 283.932 68.9088C285.513 70.6174 286.999 70.2602 286.337 71.7916Z"
                fill="#262626"
              />
              <path
                d="M292.44 97.5847C292.438 97.5949 292.319 97.5819 292.091 97.5486C291.864 97.5131 291.53 97.438 291.118 97.2868C290.302 96.9889 289.145 96.34 288.16 95.1003C287.67 94.4858 287.212 93.741 286.902 92.8653C286.585 91.9946 286.405 91.0078 286.388 89.9684C286.364 88.9285 286.511 87.8378 286.796 86.7465C286.938 86.2003 287.122 85.6553 287.337 85.1141C287.548 84.5708 287.808 84.0471 287.957 83.493C288.118 82.9406 288.096 82.3764 287.952 81.8381C287.804 81.2998 287.553 80.7936 287.309 80.2931C287.063 79.7932 286.812 79.2944 286.65 78.764C286.486 78.2381 286.424 77.6711 286.532 77.1423C286.757 76.0793 287.404 75.2927 287.785 74.4853C288.189 73.6857 288.316 72.8405 288.297 72.0821C288.229 70.5451 287.572 69.4087 287.036 68.7536C286.478 68.0979 286.055 67.848 286.076 67.8203C286.076 67.8203 286.524 68.0319 287.124 68.6791C287.698 69.3257 288.406 70.478 288.505 72.0731C288.539 72.8591 288.418 73.7495 288.005 74.5919C287.615 75.4287 286.991 76.2209 286.799 77.1937C286.6 78.1738 287.065 79.1833 287.568 80.1656C287.815 80.6667 288.076 81.1847 288.235 81.7608C288.394 82.3329 288.417 82.9796 288.243 83.5686C288.082 84.1605 287.816 84.6909 287.61 85.2213C287.399 85.7517 287.217 86.285 287.076 86.8193C286.794 87.8869 286.645 88.9505 286.661 89.9633C286.668 91.9975 287.367 93.7754 288.325 94.9705C289.264 96.1938 290.373 96.854 291.162 97.1796C291.96 97.5029 292.447 97.5514 292.44 97.5847Z"
                fill="#455A64"
              />
              <path
                d="M291.877 69.1073C291.878 69.126 291.58 69.1796 291.034 69.2326C290.491 69.2772 289.688 69.3404 288.706 69.1717C287.748 68.9967 286.537 68.5273 285.769 67.3926C285.392 66.8232 285.243 66.1343 284.998 65.4984C284.767 64.8551 284.321 64.2982 283.71 63.9122C282.473 63.1296 281.019 63.0337 279.746 62.8791C278.467 62.7352 277.266 62.4644 276.452 61.855C275.632 61.2721 275.211 60.516 275.103 59.9709C275.042 59.6978 275.047 59.4789 275.059 59.3345C275.079 59.1894 275.095 59.1155 275.105 59.1172C275.142 59.1178 275.066 59.4276 275.215 59.9427C275.351 60.4528 275.776 61.1502 276.571 61.6846C277.355 62.2392 278.504 62.4813 279.778 62.6105C281.039 62.7527 282.546 62.8311 283.87 63.6657C284.524 64.0731 285.03 64.7118 285.267 65.3951C285.518 66.0666 285.659 66.7273 285.997 67.2464C286.685 68.2965 287.826 68.7767 288.746 68.9685C289.69 69.1587 290.485 69.1293 291.027 69.1197C291.572 69.1006 291.874 69.0859 291.877 69.1073Z"
                fill="#455A64"
              />
              <path
                d="M290.473 64.5112C290.476 64.5253 290.245 64.5975 289.811 64.6082C289.38 64.6201 288.736 64.5439 288.026 64.2071C287.673 64.0395 287.31 63.7991 286.976 63.478C286.637 63.1587 286.359 62.7456 286.099 62.31C285.59 61.4518 285.099 60.3933 284.042 59.956C283.007 59.5125 281.866 59.6112 280.875 59.6783C279.875 59.7765 278.937 59.8059 278.173 59.6558C277.403 59.522 276.825 59.2038 276.505 58.9093C276.343 58.7637 276.233 58.6333 276.172 58.5369C276.109 58.4421 276.08 58.3902 276.089 58.3839C276.112 58.3659 276.247 58.5651 276.577 58.8207C276.906 59.0752 277.463 59.3477 278.207 59.451C278.951 59.5694 279.847 59.5226 280.852 59.4086C281.848 59.3302 283.022 59.2049 284.161 59.6874C284.724 59.9261 285.184 60.3487 285.51 60.8063C285.843 61.2639 286.082 61.7418 286.333 62.1735C286.583 62.6057 286.839 63.0001 287.148 63.3048C287.454 63.6135 287.789 63.8504 288.119 64.0214C288.782 64.365 289.396 64.4711 289.813 64.4937C290.234 64.5185 290.47 64.4858 290.473 64.5112Z"
                fill="#455A64"
              />
              <path
                d="M294.126 96.3588C294.097 96.3458 294.277 95.9825 294.485 95.2879C294.692 94.5955 294.898 93.555 294.862 92.2635C294.818 90.9809 294.509 89.4292 293.657 87.9548C293.243 87.2156 292.615 86.5577 292.103 85.7458C291.849 85.3406 291.63 84.8864 291.534 84.3836C291.44 83.8803 291.498 83.346 291.659 82.8607C291.976 81.8868 292.544 81.0664 292.666 80.1709C292.817 79.2726 292.363 78.4533 291.933 77.7243C291.715 77.353 291.497 76.9863 291.327 76.6026C291.158 76.2189 291.05 75.8149 291.008 75.4244C290.922 74.6401 291.014 73.9196 291.072 73.2729C291.235 71.9842 291.115 70.9251 290.804 70.2745C290.503 69.616 290.108 69.4185 290.137 69.3914C290.139 69.3875 290.163 69.3982 290.205 69.4241C290.247 69.4512 290.313 69.4868 290.385 69.5528C290.536 69.6752 290.737 69.8925 290.907 70.2248C291.265 70.8833 291.418 71.9909 291.279 73.291C291.233 73.9404 291.157 74.652 291.249 75.3951C291.325 76.145 291.712 76.8525 292.166 77.5866C292.385 77.9579 292.618 78.3456 292.78 78.7857C292.948 79.2219 293.024 79.7207 292.951 80.2104C292.813 81.1973 292.231 82.0324 291.939 82.9499C291.787 83.4081 291.738 83.8786 291.821 84.3312C291.907 84.7837 292.106 85.2052 292.348 85.5945C292.832 86.3743 293.464 87.0458 293.891 87.82C294.758 89.3519 295.05 90.9482 295.069 92.2589C295.079 93.5787 294.837 94.6322 294.594 95.3228C294.466 95.6676 294.36 95.9317 294.268 96.1021C294.184 96.2747 294.135 96.3633 294.126 96.3588Z"
                fill="#455A64"
              />
              <path
                d="M271.103 201.497C271.103 201.497 267.297 165.472 267.078 152.161C266.859 138.85 273.073 125.716 273.073 125.716L297.423 124.688C297.423 124.688 302.236 138.194 302.322 143.867C302.49 154.892 299.388 165.779 299.745 174.526L300.559 201.497"
                fill="white"
              />
              <path
                d="M301.375 157.212C301.38 157.221 301.242 157.324 300.978 157.512C300.91 157.56 300.836 157.612 300.755 157.669C300.679 157.733 300.605 157.814 300.52 157.896C300.349 158.06 300.15 158.246 299.977 158.503C299.19 159.464 298.617 161.182 298.072 163.324C297.772 164.388 297.467 165.582 296.839 166.751C296.671 167.036 296.52 167.339 296.298 167.605C296.193 167.74 296.097 167.885 295.98 168.015L295.605 168.389C295.097 168.889 294.453 169.265 293.774 169.563C292.411 170.159 290.872 170.442 289.467 171.146C288.052 171.834 286.991 173.167 286.341 174.702C285.656 176.231 285.24 177.836 284.668 179.335C284.106 180.822 283.341 182.27 282.126 183.184C280.921 184.131 279.431 184.348 278.141 184.431C276.83 184.507 275.616 184.469 274.527 184.634C273.443 184.784 272.481 185.127 271.801 185.661C271.12 186.196 270.722 186.867 270.535 187.441C270.341 188.022 270.376 188.512 270.44 188.824C270.503 189.142 270.592 189.293 270.573 189.301C270.573 189.301 270.466 189.159 270.383 188.839C270.298 188.523 270.242 188.015 270.425 187.408C270.603 186.807 270.998 186.104 271.699 185.533C272.402 184.961 273.39 184.596 274.496 184.428C275.605 184.248 276.833 184.274 278.125 184.187C279.402 184.095 280.828 183.871 281.961 182.969C283.109 182.097 283.847 180.705 284.399 179.233C284.961 177.752 285.374 176.145 286.073 174.582C286.729 173.02 287.854 171.602 289.337 170.89C290.798 170.165 292.338 169.891 293.667 169.314C294.329 169.028 294.944 168.673 295.43 168.2L295.79 167.847C295.901 167.723 295.995 167.584 296.097 167.455C296.311 167.203 296.459 166.91 296.625 166.636C297.244 165.507 297.56 164.327 297.872 163.269C298.441 161.138 299.055 159.392 299.887 158.432C300.07 158.176 300.28 157.992 300.461 157.832C300.551 157.752 300.63 157.673 300.71 157.611C300.794 157.558 300.872 157.509 300.944 157.464C301.223 157.289 301.37 157.203 301.375 157.212Z"
                fill="#141414"
                fill-opacity="0.2"
              />
              <path
                d="M301.525 140.539C301.535 140.539 301.546 140.704 301.556 141.022C301.561 141.339 301.523 141.809 301.387 142.4C301.105 143.575 300.245 145.187 298.637 146.647C297.841 147.38 296.882 148.088 295.785 148.726C294.694 149.372 293.49 149.987 292.257 150.683C291.028 151.381 289.761 152.169 288.647 153.217C287.519 154.252 286.674 155.612 285.913 157.052C285.145 158.49 284.464 159.954 283.542 161.221C283.085 161.854 282.569 162.433 281.997 162.928C281.422 163.419 280.795 163.818 280.159 164.15C278.882 164.812 277.581 165.221 276.375 165.598C275.167 165.971 274.04 166.301 273.055 166.713C272.068 167.119 271.213 167.579 270.522 168.067C269.831 168.556 269.305 169.068 268.932 169.531C268.179 170.462 268.021 171.136 267.978 171.114C267.968 171.11 268.023 170.953 268.135 170.656C268.266 170.368 268.468 169.939 268.842 169.46C269.207 168.978 269.732 168.444 270.425 167.934C271.119 167.425 271.98 166.946 272.973 166.522C273.966 166.092 275.099 165.748 276.301 165.366C277.501 164.98 278.787 164.564 280.032 163.91C280.652 163.583 281.259 163.192 281.813 162.715C282.363 162.235 282.862 161.674 283.307 161.054C284.204 159.814 284.879 158.362 285.652 156.914C286.415 155.468 287.285 154.069 288.448 153.007C289.592 151.937 290.882 151.143 292.122 150.447C293.366 149.754 294.571 149.148 295.659 148.516C296.751 147.893 297.701 147.206 298.494 146.493C300.096 145.075 300.962 143.515 301.275 142.371C301.581 141.216 301.479 140.536 301.525 140.539Z"
                fill="#141414"
                fill-opacity="0.2"
              />
              <path
                d="M267.201 154.071C267.197 154.073 267.18 154.036 267.152 153.962C267.128 153.887 267.076 153.778 267.043 153.626C266.974 153.325 266.931 152.849 267.099 152.274C267.413 151.125 268.664 149.695 270.678 148.979C271.681 148.635 272.818 148.428 274.003 148.118C275.174 147.803 276.45 147.362 277.403 146.384C277.876 145.902 278.276 145.327 278.609 144.696C278.933 144.059 279.201 143.375 279.453 142.669C279.96 141.262 280.385 139.733 281.245 138.342C282.1 136.941 283.492 135.968 284.932 135.48C286.369 134.953 287.818 134.72 289.163 134.41C290.511 134.117 291.772 133.738 292.842 133.16C293.896 132.562 294.736 131.765 295.331 130.921C296.55 129.229 296.87 127.496 296.913 126.35C296.94 125.186 296.754 124.553 296.793 124.547C296.793 124.547 297.018 125.17 297.027 126.352C297.018 127.515 296.728 129.291 295.501 131.041C294.901 131.914 294.047 132.744 292.961 133.372C291.864 133.978 290.577 134.372 289.224 134.674C287.872 134.992 286.432 135.232 285.033 135.75C283.626 136.234 282.319 137.155 281.495 138.499C280.665 139.838 280.238 141.35 279.726 142.766C279.47 143.477 279.195 144.172 278.859 144.826C278.514 145.476 278.094 146.074 277.595 146.577C276.583 147.602 275.249 148.046 274.065 148.354C272.864 148.657 271.733 148.852 270.745 149.177C268.784 149.845 267.541 151.214 267.209 152.308C267.031 152.856 267.053 153.316 267.101 153.615C267.164 153.912 267.214 154.067 267.201 154.071Z"
                fill="#141414"
                fill-opacity="0.2"
              />
              <path
                d="M299.431 184.531C299.441 184.53 299.454 184.651 299.47 184.886C299.484 185.119 299.465 185.468 299.366 185.904C299.167 186.773 298.494 187.962 297.23 188.953C296.608 189.454 295.854 189.914 294.989 190.282C294.126 190.651 293.172 190.943 292.175 191.253C291.179 191.564 290.134 191.888 289.119 192.368C288.095 192.835 287.151 193.52 286.337 194.393C285.512 195.255 284.801 196.197 284.011 197.029C283.226 197.866 282.333 198.555 281.406 199.064C279.546 200.089 277.618 200.441 276.031 200.459C274.433 200.477 273.164 200.141 272.332 199.845C271.912 199.699 271.6 199.553 271.393 199.443C271.184 199.34 271.077 199.28 271.081 199.271C271.086 199.262 271.202 199.303 271.417 199.389C271.63 199.481 271.947 199.609 272.368 199.737C273.202 199.996 274.458 200.294 276.027 200.251C277.584 200.207 279.467 199.839 281.273 198.827C282.174 198.322 283.033 197.653 283.8 196.831C284.573 196.012 285.281 195.07 286.123 194.19C286.951 193.299 287.946 192.579 288.994 192.107C290.037 191.619 291.096 191.298 292.094 190.994C293.094 190.691 294.043 190.409 294.893 190.057C295.742 189.708 296.485 189.269 297.1 188.79C298.351 187.843 299.026 186.712 299.255 185.875C299.479 185.029 299.391 184.53 299.431 184.531Z"
                fill="#141414"
                fill-opacity="0.2"
              />
              <path
                d="M296.656 109.731L291.947 109.842C291.638 111.426 290.882 112.509 290.882 112.509C286.945 105.686 283.892 96.5447 283.134 92.8708C283.245 92.504 283.376 92.0977 283.539 91.6441C283.727 91.1204 283.566 90.1284 283.477 89.5783C283.345 88.7601 283.116 87.6597 283.047 87.1502C282.837 85.5979 282.587 85.3541 282.044 85.5296C281.307 85.7683 282.347 89.8892 281.742 89.9789C281.417 90.0269 281.019 88.615 280.904 87.4566C280.789 86.2982 280.264 82.7348 279.881 82.4972C279.318 82.1491 278.828 82.6998 278.97 83.8532C279.114 85.0206 279.295 88.5028 278.682 88.5496C278.078 88.5959 277.571 82.6885 277.571 82.6885C277.571 82.6885 277.666 81.4031 276.956 81.4341C275.675 81.4894 276.676 87.7179 276.786 88.3081C276.863 88.7183 276.197 88.7939 276.139 88.3482C276.078 87.8894 275.77 82.4402 274.466 82.4837C273.465 82.5175 275.241 87.6163 274.679 88.7984C274.117 89.98 273.727 84.7842 272.772 84.8559C272.416 84.883 272.153 84.9524 272.807 87.8928C273.158 89.4733 274.19 92.3787 275.091 94.7848C276.605 102.938 283.251 129.022 293.669 124.248C299.499 121.576 301.864 109.735 301.864 109.735L296.656 109.731Z"
                fill="#FFD1CA"
              />
              <path
                d="M276.565 88.6998C276.565 88.6998 276.612 88.7083 276.7 88.6812C276.78 88.657 276.938 88.5576 276.913 88.3551C276.899 88.0052 276.844 87.4946 276.763 86.835C276.703 86.1709 276.504 85.3741 276.503 84.4313C276.495 83.959 276.508 83.4511 276.535 82.9129C276.552 82.6437 276.557 82.3644 276.617 82.1003C276.661 81.8447 276.833 81.5524 277.03 81.5874L277.051 81.5914L277.061 81.5908C277.262 81.5818 277.419 81.7381 277.484 81.9773C277.554 82.2058 277.572 82.4756 277.558 82.7329L277.557 82.7436L277.558 82.7509C277.69 84.1943 277.832 85.7747 278.162 87.4619C278.208 87.6729 278.255 87.8851 278.32 88.0989C278.353 88.2056 278.391 88.3133 278.438 88.4222C278.468 88.4781 278.487 88.5311 278.534 88.5892C278.574 88.6383 278.625 88.7241 278.77 88.7371C279.005 88.7196 279.072 88.5424 279.126 88.4408C279.176 88.324 279.208 88.2084 279.231 88.0938C279.28 87.8642 279.304 87.6351 279.322 87.4049C279.384 86.4846 279.352 85.5457 279.284 84.5825C279.262 84.0955 279.143 83.6103 279.226 83.169C279.264 82.9518 279.355 82.7329 279.504 82.6426C279.576 82.5986 279.657 82.5895 279.747 82.6121C279.791 82.6251 279.837 82.6431 279.881 82.6702C279.919 82.7058 279.91 82.69 279.943 82.7532C280.133 83.1572 280.229 83.6831 280.336 84.1717C280.436 84.6711 280.523 85.18 280.602 85.6946C280.682 86.2092 280.755 86.73 280.817 87.2548C280.867 87.779 280.943 88.3297 281.077 88.8595C281.145 89.1264 281.22 89.3927 281.332 89.6568C281.39 89.7894 281.449 89.9203 281.565 90.0557C281.607 90.1133 281.739 90.2211 281.904 90.1787C282.063 90.1257 282.108 89.9993 282.134 89.9254C282.226 89.601 282.199 89.3312 282.194 89.0474C282.182 88.7676 282.158 88.4905 282.135 88.214C282.095 87.7389 282.049 87.2689 282.034 86.8056C282.026 86.5749 282.026 86.3441 282.05 86.1268C282.065 86.0208 282.083 85.9113 282.119 85.8329C282.136 85.7928 282.158 85.7635 282.174 85.7488C282.183 85.7398 282.188 85.7437 282.196 85.7347L282.269 85.7138C282.644 85.5592 282.769 86.08 282.868 86.4998C282.955 86.9377 283.01 87.3896 283.098 87.8348C283.247 88.7235 283.437 89.6066 283.536 90.4558C283.577 90.8762 283.608 91.3135 283.487 91.6701C283.353 92.078 283.22 92.4815 283.09 92.8804L283.078 92.9165L283.086 92.9543C283.775 95.9883 284.73 98.7029 285.615 101.113C286.51 103.521 287.405 105.602 288.194 107.303C288.981 109.006 289.688 110.318 290.176 111.214C290.423 111.638 290.619 111.973 290.764 112.222C290.9 112.45 290.975 112.566 290.982 112.562C290.99 112.557 290.93 112.433 290.809 112.198C290.674 111.943 290.493 111.6 290.264 111.167C289.804 110.258 289.126 108.936 288.365 107.226C287.601 105.517 286.73 103.433 285.856 101.025C284.991 98.6177 284.053 95.8958 283.383 92.8934L283.38 92.9673C283.51 92.5734 283.643 92.1756 283.776 91.7733C283.928 91.3129 283.883 90.8632 283.846 90.4231C283.744 89.5406 283.56 88.6829 283.412 87.7903C283.325 87.349 283.271 86.8959 283.18 86.4332C283.127 86.2024 283.077 85.97 282.95 85.7347C282.889 85.6207 282.794 85.4909 282.638 85.421C282.48 85.3527 282.318 85.3719 282.192 85.4029L282.097 85.43C282.054 85.4492 282.001 85.4717 281.969 85.5028C281.896 85.5654 281.855 85.6371 281.826 85.7036C281.766 85.8391 281.749 85.9638 281.732 86.089C281.703 86.3367 281.705 86.5777 281.712 86.8169C281.728 87.2954 281.775 87.7688 281.815 88.2422C281.838 88.5176 281.861 88.7918 281.873 89.0621C281.883 89.3256 281.892 89.6168 281.831 89.8204C281.817 89.8797 281.789 89.8684 281.822 89.8972L281.823 89.9C281.82 89.8808 281.827 89.9288 281.826 89.9209L281.825 89.9152C281.824 89.9079 281.825 89.9011 281.827 89.8955C281.829 89.8904 281.842 89.8707 281.835 89.8695C281.831 89.8678 281.817 89.8605 281.801 89.8385C281.738 89.7668 281.676 89.6495 281.628 89.5327C281.527 89.2963 281.453 89.0395 281.388 88.7839C281.258 88.2665 281.185 87.753 281.133 87.2198C281.07 86.6888 280.996 86.1658 280.914 85.6478C280.833 85.1298 280.744 84.6175 280.641 84.1119C280.525 83.6029 280.45 83.1137 280.212 82.6053C280.197 82.554 280.097 82.44 280.034 82.4067C279.971 82.3689 279.9 82.3396 279.824 82.3181C279.672 82.2764 279.486 82.2956 279.346 82.3841C279.066 82.5692 278.979 82.8632 278.928 83.1182C278.883 83.3812 278.889 83.6407 278.919 83.8913C278.947 84.1322 278.97 84.3681 278.989 84.6067C279.061 85.5569 279.096 86.4919 279.041 87.3857C279.025 87.6086 279.002 87.8292 278.959 88.0374C278.938 88.1418 278.91 88.2428 278.873 88.3297C278.855 88.3726 278.832 88.4126 278.811 88.4352C278.791 88.482 278.773 88.4245 278.775 88.5007C278.803 88.4425 278.776 88.4747 278.754 88.4262C278.729 88.3997 278.709 88.3489 278.686 88.3094C278.646 88.2174 278.611 88.1203 278.58 88.0199C278.517 87.8196 278.469 87.612 278.424 87.4071C278.088 85.7499 277.93 84.1655 277.785 82.7323V82.7503C277.797 82.4603 277.778 82.1833 277.693 81.9113C277.65 81.7776 277.587 81.641 277.472 81.5355C277.359 81.4266 277.198 81.3781 277.053 81.3826L277.084 81.386C276.857 81.3459 276.691 81.483 276.597 81.619C276.5 81.759 276.457 81.9107 276.423 82.0574C276.361 82.3537 276.362 82.6352 276.348 82.9055C276.328 83.4483 276.323 83.959 276.339 84.4363C276.357 85.399 276.574 86.1957 276.651 86.8519C276.749 87.5076 276.823 88.0165 276.855 88.3596C276.89 88.5227 276.759 88.6276 276.69 88.6553C276.61 88.688 276.564 88.6931 276.565 88.6998Z"
                fill="black"
                fill-opacity="0.1"
              />
              <path
                d="M239.755 117.505C239.755 117.505 238.191 117.43 236.481 117.879C233.562 118.646 228.523 121.694 228.315 125.461H231.975C231.975 125.461 229.925 129.816 230.528 129.413C232.09 128.367 235.201 125.211 235.201 125.211L239.755 117.505Z"
                fill="#FFD1CA"
              />
              <path
                d="M289.677 51.9408C289.596 51.9482 289.263 48.9272 288.934 45.1946C288.605 41.4604 288.405 38.4287 288.486 38.4219C288.566 38.4146 288.899 41.435 289.228 45.1692C289.557 48.9012 289.757 51.9335 289.677 51.9408Z"
                fill="white"
              />
              <path
                d="M305.733 38.6059C305.799 38.6528 303.326 42.2358 300.211 46.6071C297.095 50.98 294.515 54.4857 294.448 54.4389C294.382 54.3921 296.854 50.8096 299.971 46.4366C303.086 42.0654 305.666 38.5591 305.733 38.6059Z"
                fill="white"
              />
              <path
                d="M312.404 54.8437C312.421 54.9233 309.535 55.5823 305.96 56.3159C302.383 57.0494 299.472 57.5798 299.456 57.5002C299.439 57.4207 302.325 56.7616 305.901 56.0281C309.476 55.2951 312.388 54.7647 312.404 54.8437Z"
                fill="white"
              />
              <path
                d="M120.175 132.344L100.189 234.928L97.5723 248.357L230.995 247.7C236.982 247.67 242.289 242.362 244.216 234.476L267.874 137.627C269.337 131.64 266.128 125.413 261.582 125.418L126.543 125.56C123.562 125.564 120.955 128.341 120.175 132.344Z"
                fill="#4A7AF2"
              />
              <g opacity="0.5">
                <path
                  d="M120.175 132.344L100.189 234.928L97.5723 248.357L230.995 247.7C236.982 247.67 242.289 242.362 244.216 234.476L267.874 137.627C269.337 131.64 266.128 125.413 261.582 125.418L126.543 125.56C123.562 125.564 120.955 128.341 120.175 132.344Z"
                  fill="#141414"
                />
              </g>
              <path
                d="M218.196 227.979L204.07 114.331C203.491 109.674 199.775 106.2 195.388 106.215L164.412 106.316C162.12 106.323 159.921 107.297 158.293 109.025L143.583 124.635L57.4323 125.084C52.1675 125.112 48.1229 130.085 48.8209 135.673L61.937 240.713C62.5174 245.363 66.2262 248.832 70.6071 248.823L220.75 248.527C237.473 248.873 239.069 243.942 239.069 243.942C219.905 248.183 218.198 227.992 218.196 227.979Z"
                fill="#4A7AF2"
              />
              <path
                d="M153.456 205.234L148.392 210.663L109.392 175.636L114.456 170.207L153.456 205.234Z"
                fill="white"
              />
              <path
                d="M146.27 169.004L151.867 174.03L116.579 211.868L110.982 206.842L146.27 169.004Z"
                fill="white"
              />
              <path
                d="M239.636 58.5614C239.275 58.4068 239.015 58.0564 238.996 57.6383L238.771 52.3998C238.756 52.0703 238.898 51.7531 239.152 51.5432C239.406 51.3328 239.745 51.2543 240.066 51.33C240.91 51.5286 241.84 51.3452 242.618 50.8266C243.335 50.3493 243.816 49.6462 243.937 48.8975C244.06 48.1515 243.828 47.326 243.303 46.632C242.741 45.8889 241.91 45.3884 241.076 45.293C239.374 45.0972 237.537 46.3989 237.064 48.1357C236.911 48.6966 236.332 49.0284 235.77 48.8755C235.198 48.7186 234.876 48.1442 235.028 47.5833C235.771 44.8535 238.592 42.8876 241.318 43.2008C242.731 43.3633 244.07 44.151 244.985 45.3618C245.857 46.5129 246.233 47.9247 246.019 49.236C245.803 50.5592 244.99 51.7768 243.789 52.5775C242.921 53.1559 241.925 53.4753 240.929 53.5097L241.104 57.5475C241.129 58.1287 240.677 58.6196 240.095 58.6444C239.932 58.6517 239.776 58.6213 239.636 58.5614Z"
                fill="#FF2A2A"
              />
              <path
                d="M241.182 60.7051C241.214 61.1796 240.856 61.591 240.38 61.6231C239.905 61.6559 239.493 61.2976 239.46 60.823C239.427 60.3485 239.786 59.9371 240.262 59.9044C240.737 59.8717 241.149 60.2306 241.182 60.7051Z"
                fill="#FF2A2A"
              />
              <path
                d="M221.473 51.1713C221.48 51.1713 221.497 51.0551 221.524 50.8277C221.55 50.5822 221.588 50.2481 221.635 49.8187C221.66 49.3724 221.774 48.833 221.908 48.197C221.983 47.881 222.021 47.5295 222.137 47.174C222.247 46.8163 222.364 46.4365 222.487 46.0347C223.035 44.4503 223.878 42.5498 225.298 40.6595C226.708 38.7732 228.69 36.9094 231.234 35.4976C232.487 34.7516 233.92 34.2319 235.422 33.7732C236.948 33.4126 238.565 33.1034 240.254 33.1434C241.099 33.0983 241.951 33.2219 242.819 33.2947C243.252 33.3359 243.679 33.4515 244.115 33.5271C244.551 33.6073 244.989 33.6925 245.415 33.8403C247.16 34.2872 248.855 35.1088 250.47 36.1273C253.713 38.1637 256.443 41.4771 257.941 45.4936C258.692 47.503 259.052 49.7059 259.049 51.9308C259.094 54.1602 258.661 56.4246 257.867 58.5565L257.612 59.2009L257.578 59.2861L257.613 59.3656C259.03 62.6254 260.421 65.8226 261.768 68.9204L262.006 68.6507C259.087 67.5312 256.256 66.4455 253.541 65.4039L253.437 65.3638L253.355 65.4434C251.006 67.7151 248.201 69.2505 245.362 70.0506C242.513 70.8525 239.644 70.8937 237.035 70.4304C234.419 69.9683 232.065 68.9695 230.101 67.6858C228.132 66.4021 226.553 64.8413 225.336 63.2551C224.127 61.6515 223.331 60.0072 222.73 58.5384C222.201 57.0374 221.877 55.7052 221.719 54.6026C221.653 54.0519 221.593 53.5621 221.542 53.135C221.531 52.7129 221.522 52.354 221.514 52.0566C221.505 51.7796 221.497 51.5606 221.492 51.3959C221.485 51.2475 221.479 51.1713 221.473 51.1713C221.468 51.1713 221.463 51.2463 221.459 51.3953C221.457 51.5606 221.454 51.779 221.451 52.0578C221.45 52.3563 221.449 52.718 221.449 53.1423C221.493 53.5728 221.542 54.0666 221.599 54.6218C221.738 55.7351 222.047 57.0837 222.565 58.6067C223.155 60.0969 223.946 61.7689 225.156 63.403C226.376 65.0196 227.966 66.6131 229.956 67.9279C231.94 69.2426 234.326 70.2701 236.981 70.752C239.629 71.2339 242.546 71.204 245.448 70.3971C248.34 69.5925 251.202 68.0356 253.601 65.7244L253.414 65.7639C256.128 66.8095 258.956 67.8996 261.874 69.0237L262.301 69.1879L262.112 68.7539C260.767 65.655 259.379 62.4573 257.963 59.1969L257.964 59.3611L258.224 58.7026C259.037 56.524 259.477 54.2076 259.432 51.9291C259.433 49.6551 259.063 47.4031 258.293 45.3509C256.758 41.248 253.965 37.8765 250.657 35.8102C249.009 34.7764 247.28 33.947 245.504 33.4967C245.069 33.3483 244.623 33.2631 244.18 33.1829C243.737 33.1073 243.303 32.9916 242.862 32.951C241.979 32.8805 241.113 32.7592 240.255 32.8083C238.538 32.7755 236.896 33.096 235.349 33.4713C233.825 33.9447 232.374 34.4813 231.107 35.2453C228.535 36.6938 226.54 38.5982 225.13 40.5207C223.709 42.4466 222.876 44.378 222.347 45.984C222.228 46.3908 222.116 46.7762 222.01 47.1379C221.899 47.4979 221.866 47.8528 221.797 48.1722C221.674 48.8155 221.571 49.3594 221.558 49.8091C221.527 50.2408 221.503 50.5782 221.485 50.8248C221.471 51.0539 221.467 51.1707 221.473 51.1713Z"
                fill="#FF2A2A"
              />
            </svg>
          </Box>
          <Typography
            mb="20px"
            variant="h5"
            className="text-white"
            fontWeight="bold"
            textAlign="center"
          >
            Delete Wolfpack Account?
          </Typography>
          <Typography
            variant="subtitle1"
            mb="20px"
            width="75%"
            marginX="auto"
            className="text-white"
            textAlign="center"
            lineHeight="24px"
          >
            Are you sure you want to delete your Wolfpack Account? Once this
            action is performed, it cannot be reversed.
          </Typography>
          <FormControl fullWidth className="text-white" sx={{ mt: "20px" }}>
            <InputLabel className="text-white">
              Confirm Delete{" "}
              <i
                className="fa-solid fa-star-of-life"
                style={{ color: "#fa0000", fontSize: "0.5rem" }}
              ></i>
              (Write <span style={{ color: "#fa0000" }}>“Delete”</span> in field
              below for confirmation).
            </InputLabel>
            <TextField
              value={input}
              onChange={(e) => setInput(e.target.value)}
              variant="outlined"
              className="text-secondary"
            />
          </FormControl>
        </DialogContent>
        <Divider sx={{ mb: "20px", border: "1px solid #FFFFFF33" }} />
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          mb="20px"
        >
          <ButtonGroup
            style={{
              width: "fit-content",
              display: "flex",
              alignItems: "center",
              gap: "20px",
            }}
          >
            <Button
              variant="outlined"
              className="btn"
              sx={{
                color: "#FF2A2A",
                fontWeight: "bold",
                borderColor: "#FF2A2A",
                padding: "12px 50px",
                fontSize: "16px",
                "&:hover": {
                  color: "#FF2A2A !important",
                  borderColor: "#FF2A2A !important",
                },
              }}
              onClick={handleaccount}
            >
              Go Back
            </Button>
            <Button
              variant="contained"
              color="primary"
              className=" btn "
              sx={{
                padding: "12px 22px",
                fontWeight: "bold",
                bgcolor: "#FF2A2A",
                fontSize: "16px",
                "&:hover": {
                  bgcolor: "#FF2A2A !important",
                  color: "white",
                },
              }}
              onClick={handleDeleteAccount}
            >
              Confirm Delete
            </Button>
          </ButtonGroup>
        </Box>
      </Dialog>
      {showPopup && <Successpopup Heading={heading} Success={Success} onClose={closePopup} Message={msg} />}

    </>
  );
}

export default Setting;
